export const updateMarkerList = (tableList, markerList, setMarkerListHandle) => {
  // init
  setMarkerListHandle([]);
  // eslint-disable-next-line array-callback-return
  tableList.map((elem) => {
    AddMarker(elem, markerList, setMarkerListHandle);
  });
};

const AddMarker = (elem, markerList, setMarkerListHandle) => {
  let type = '';
  let color = ''
  let id = ''
  if (elem.sensor_ty === 0) {
    console.log('0000000');
  } else if (elem.sensor_ty === 1) {
    type = 'Fire';
    id = elem.sensor_no.toString();
    color = '#f79646';
  } else if (elem.sensor_ty === 2) {
    type = 'Motion';
    id = elem.sensor_no.toString();
    color = '#ff4351';
  } else if (elem.sensor_ty === 3) {
    type = 'Bell';
    id = elem.sensor_no.toString();
    color = '#e077e0';
  } else {
    type = 'Rep';
    id = elem.rpeat_no.toString();
    color = '#b8ef60';
  }

  setMarkerListHandle((markerList) => {
    const newMarkerList = [...markerList];
    newMarkerList.push({
      id: id,
      type: type,
      status: 'Normal',
      color: color,
      x: elem.setup_yn === 'Y' ? elem.x_crdnt : '0',
      y: elem.setup_yn === 'Y' ? elem.y_crdnt : '0',
      setup_yn: 'Y', //elem.setup_yn,
      isModified: false,
      rpeat_id: elem.rpeat_id,
      sensor_no: elem.sensor_no,
      sensor_id: elem.sensor_id,
      rpeat_lc_nm: elem.rpeat_lc_nm,
      sensor_lc_nm: elem.sensor_lc_nm,
      sync_yn_nm: elem.sync_yn_nm,
      fclty_nm: elem.fclty_nm,
      fclty_dtl_nm: elem.fclty_dtl_nm,
      modl: elem.modl,
      fw_ver: elem.fw_ver,
    });
    return newMarkerList;
  })
}